// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type DndTeamInfoResponse = SlackAPIResponse & {
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
  users?: { [key: string]: User };
};

export interface User {
  dnd_enabled?: boolean;
  next_dnd_end_ts?: number;
  next_dnd_start_ts?: number;
}
